import { apiGet, apiPatch, ApiResponse } from "./apiService";
import { RequestLOAUserAssign, LOADetail, User } from "@/models/loa";

export function getUsersAsync(): Promise<ApiResponse<User[]>> {
    return apiGet<User[]>("/LOAOperations/getusers");
}

export function getDetailsAsync(sysId: string): Promise<ApiResponse<LOADetail>> {
    return apiGet<LOADetail>("/LOAOperations/getdetails/" + sysId);
}

export function setUserAssignAsync(request: RequestLOAUserAssign): Promise<ApiResponse> {
    return apiPatch("/LOAOperations/updatepolicyandclaimassignment", request);
}